/**
 * Created by antonio on 26/09/14.
 */
define('payment/templates/form-template',['jquery', 'all/comeon', 'boxes/helpers/formValidation', 'payment/handlers/sendHandlers/resultAfterSingleCallHandler', 'payment/handlers/sendHandlers/pendingAfterSingleCallHandler', 'payment/handlers/sendHandlers/externalPanelHandler', 'payment/handlers/sendHandlers/externalWindowHandler', 'payment/handlers/sendHandlers/sendHandlerController', 'payment/handlers/sendHandlers/internalPanelHandler', 'payment/handlers/sendHandlers/asynchronousResultAfterSingleCallHandler', 'payment/handlers/sendHandlers/externalWindowIframeHandler', 'all/jquery/jquery.mustache'], function ($, comeon, formValidation, resultAfterSingleCallHandler, pendingAfterSingleCallHandler, externalPanelHandler, externalWindowHandler, sendHandlerController, internalPanelHandler, asynchronousResultAfterSingleCallHandler, externalWindowIframeHandler) {
	'use strict';

	var sendHandlers = {
		RESULT_AFTER_SINGLE_CALL : resultAfterSingleCallHandler,
		PENDING_RESULT_AFTER_SINGLE_CALL : pendingAfterSingleCallHandler,
		EXTERNAL_PANEL : externalPanelHandler,
		EXTERNAL_WINDOW : externalWindowHandler,
		SEND_HANDLER_CONTROLLER : sendHandlerController,
		INTERNAL_PANEL : internalPanelHandler,
		ASYNCHRONOUS_RESULT_AFTER_SINGLE_CALL: asynchronousResultAfterSingleCallHandler,
		EXTERNAL_WINDOW_IFRAME: externalWindowIframeHandler
	};

	function addSummaryPostFix(useSummaryTemplate) {
		if (useSummaryTemplate === true) {
			return '-summary';
		}
		return '';
	}

	return {
		create: function (paymentMethodData) {
			var data = {
				initialised: false,
				sendHandler: sendHandlers[paymentMethodData.sendHandlerType],
				paymentMethod: paymentMethodData,
				formTemplateData: undefined
			};
			return comeon.create(this.api, data);
		},
		api: {
			init: function(controller, initPromise) {
				if(this.initialised) {
					initPromise.resolve();
					return;
				}

				var formTemplateCode = this.paymentMethod.formTemplateCode;
				var formTemplateUrl = controller.formTemplateTypes[formTemplateCode].formTemplateUrl;
				if(typeof(formTemplateUrl) === 'undefined' || formTemplateUrl === null) {
					initPromise.resolve();
					return;
				}
				var self = this;
				var params = this.paymentMethod.formTemplateUrlParams + '&isMobile=false';
				$.post(formTemplateUrl, params, function (data) {
					self.formTemplateData = data;
					self.initialised = true;
					$.Mustache.addFromDom(self.getMustacheClass());
					initPromise.resolve();

					console.info('response data from formTemplateUrl: ');
					console.info(data);
				});
			},
			render: function(controller, paymentsInstance) {
				controller.renderer.render(this, paymentsInstance);
			},
			send: function(controller, paymentsInstance) {
				controller.sender.send(this, paymentsInstance);
			},
			getSelectorClass: function() {
				return '.payment-method-form.' + this.paymentMethod.formTemplateCode.toLowerCase();
			},
			getMustacheClass: function() {
				var useSummaryTemplate =
					this.initialised === true &&
					typeof(this.formTemplateData.hasAccounts) !== 'undefined' &&
					this.paymentMethod.paymentType === 'withdraw';

				var formTemplateToUse = this.paymentMethod.formTemplateCode.toLowerCase() + addSummaryPostFix(useSummaryTemplate) + '-template';

				console.info('formTemplateToUse: ' + formTemplateToUse);

				return formTemplateToUse;
			}
		}
	};
});

